<template>
  <div
    class="sf-inbox-companies-item"
    :class="{ active: isActive }"
    @click="$emit('click', id)"
  >
    <div :class="hideSessionClass">{{ name }}</div>
    <div v-if="unreadNotifications > 0" class="sf-label">
      {{ unreadNotifications }}
    </div>
  </div>
</template>

<script>
import useRedactSessionRecording from '@app/shared/vue/composables/use-hide-session-recording'

export default {
  props: ['id', 'name', 'unreadNotifications', 'isActive'],
  emits: ['click'],
  setup() {
    const hideSessionClass = useRedactSessionRecording({
      shouldHideIfPulse: true,
    })
    return hideSessionClass
  },
}
</script>
